import styled from 'styled-components'

import { SDB, SDR, SO, SG } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'

const colors = {
  blue: SDB,
  red: SDR,
  orange: SO,
  green: SG
}
const CapitalizedHeading = styled(Heading)`
  text-transform: uppercase;
`
const PromotionPreHeading = ({ children, color }) => (
  <CapitalizedHeading level="5" removeMargins={true} color={colors[color]}>
    {children}
  </CapitalizedHeading>
)

export { PromotionPreHeading }
